import CardinalDirectionNode from "./action/direction/CardinalDirectionNode"
import ChaosDirectionNode from "./action/direction/ChaosDirectionNode"
import DirectionMouseNode from "./action/direction/DirectionMouseNode"
import RotationNode from "./action/direction/RotationNode"
import VelocityDirectionNode from "./action/direction/VelocityDirectionNode"
import CloneNode from "./action/element/CloneNode"
import FireNode from "./action/element/FireNode"
import ManaSparkNode from "./action/element/ManaSparkNode"
import OnDeathEventNode from "./action/event/OnDeathEventNode"
import SwapNode from "./action/force/SwapNode"
import VelocityNode from "./action/force/VelocityNode"
import ConnectorNode from "./action/logistics/ConnectorNode"
import ErrorNode from "./action/logistics/ErrorNode"
import KeyGateNode from "./action/logistics/KeyGateNode"
import LoopZoneNode from "./action/logistics/LoopZoneNode"
import PortalNode from "./action/logistics/PortalNode"
import RandomPathNode from "./action/logistics/RandomPathNode"
import ResistanceNode from "./action/logistics/ResistanceNode"
import SleepNode from "./action/logistics/SleepNode"
import SwitchZoneNode from "./action/logistics/SwitchZoneNode"
import TargetCasterNode from "./action/targeting/TargetCasterNode"
import ManaSource from "./action/unique/ManaSource"
import NodeCategories from "./NodeCategories"

type RegisteredNode = {
	name: string,
	desc: string,
	category: NodeCategories,
	symbol: string,
	create: any,
	type: string,
}
export default class NodeRegistry {
	static registeredNodes = [] as RegisteredNode[]

	static getNodes() {
		return [...this.registeredNodes]
	}

	static register() {
		[
			// Elements
			ManaSparkNode,
			FireNode,
			CloneNode,

			// Force
			VelocityNode,
			SwapNode,

			// Direction
			DirectionMouseNode,
			RotationNode,
			CardinalDirectionNode,
			VelocityDirectionNode,
			ChaosDirectionNode,

			// Logistics
			ConnectorNode,
			KeyGateNode,
			SleepNode,
			RandomPathNode,
			ErrorNode,
			ResistanceNode,
			LoopZoneNode,
			PortalNode,
			SwitchZoneNode,

			// Event
			OnDeathEventNode,

			// Targeting
			TargetCasterNode,

			// Unique
			ManaSource,


		].forEach((Klass) => this.registerNode(Klass))
	}

	static registerNode(Klass: any) {
		this.registeredNodes.push({
			name: Klass.nodeName,
			desc: Klass.nodeDesc,
			category: Klass.category,
			symbol: Klass.nodeIcon || '❔',
			create: Klass,
			type: Klass.nodeType
		})
	}
}